import { useEffect, useRef, type ComponentProps } from 'react';
import { releaseVideo } from '@/lib/preloadMedia';

type Props = ComponentProps<'video'> & {
  register: (video: HTMLVideoElement | null) => void;
};

/** Preserve the DOM element across updates, release its decoder only on unmount. */
export function ScreensaverVideo({ register, ...props }: Props) {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  useEffect(() => {
    const video = videoRef.current;
    return () => { if (video) releaseVideo(video); };
  }, []);
  return <video {...props} ref={video => { videoRef.current = video; register(video); }} />;
}
